// extracted by css-extract-rspack-plugin
export default {"cls1":"ChatInterface-cls1_5gd","cls2":"ChatInterface-cls2_LB5 ChatInterface-cls1_5gd"};